import { Loader2 } from 'lucide-react';
import { motion } from 'motion/react';
import { useDashboardMotion } from '@primitive/motion';

export const PageLoader = () => {
    const { shouldReduceMotion } = useDashboardMotion();

    if (shouldReduceMotion) {
        return (
            <div className="flex min-h-screen w-full flex-1 items-center justify-center text-muted-foreground">
                <Loader2 className="mr-2 size-5 animate-spin" />
                <span>Loading ...</span>
            </div>
        );
    }

    return (
        <div className="flex min-h-screen w-full flex-1 items-center justify-center bg-background text-muted-foreground">
            <div className="flex flex-col items-center gap-4">
                <motion.div
                    className="grid grid-cols-2 gap-1.5"
                    aria-hidden="true"
                    initial="initial"
                    animate="animate"
                >
                    {Array.from({ length: 4 }).map((_, index) => (
                        <motion.span
                            key={`page-loader-block-${index}`}
                            className="size-3 rounded-[4px] bg-primary/80 shadow-sm"
                            variants={{
                                initial: { opacity: 0.45, y: 0, scale: 0.92 },
                                animate: {
                                    opacity: [0.45, 1, 0.55],
                                    y: [0, -4, 0],
                                    scale: [0.92, 1, 0.96],
                                    transition: {
                                        duration: 0.9,
                                        repeat: Infinity,
                                        delay: index * 0.11,
                                        ease: "easeInOut",
                                    },
                                },
                            }}
                        />
                    ))}
                </motion.div>
                <motion.p
                    className="text-sm font-medium"
                    initial={{ opacity: 0.6 }}
                    animate={{ opacity: [0.6, 1, 0.6] }}
                    transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
                >
                    Loading ...
                </motion.p>
            </div>
        </div>
    );
};
